import { match } from '@formatjs/intl-localematcher';
import { extractSubdomain } from '@util/getURL';
import Negotiator from 'negotiator';
import { Config } from 'next-i18n-router/dist/types';
import { NextRequest } from 'next/server';

const i18nConfig = {
  locales: ['en', 'en-US', 'es', 'fr-CA'],
  defaultLocale: 'en',
  prefixDefault: true,
  localeDetector: (req: NextRequest, config: Config) => {
    // This detector will not run if the NEXT_LOCALE cookie is set.
    // Manually choose french for certain domains.
    const host = req.headers.get('host');
    const subdomain = extractSubdomain(host);
    const isFrenchPreferredSubdomain =
      subdomain &&
      ['montreal', 'cantonsdelest', 'outaouais', 'tremblant', 'quebec'].includes(subdomain);
    if (isFrenchPreferredSubdomain) {
      return 'fr-CA';
    }

    // Below is the default locale detector logic
    const negotiatorHeaders: Record<string, string> = {};
    req.headers.forEach((value, key) => (negotiatorHeaders[key] = value));
    const languages = new Negotiator({ headers: negotiatorHeaders }).languages();

    try {
      return match(languages, config.locales, config.defaultLocale);
    } catch (e) {
      return config.defaultLocale;
    }
  },
};

export default i18nConfig;
